export default __webpack_public_path__ + "static/media/GetGrowCart_Icon_Only.1ec97d3b.jpg";